import { ref, watch } from "vue";
import { PersonalData } from "../models/personal-data";
import { BusinessCardData } from "../models/business-card-data";
import { useRegistrationStore } from "./use-player-registration-data";

const registrationPersonalData = ref<PersonalData>({
    isBankIdUsed: false,
    firstName: "",
    lastName: "",
    phone: "",
    street: "",
    city: "",
    zipCode: null,
    countryOfBirth: "",
    cityOfBirth: "",
    citizenship: "",
    citizenshipId: "",
    hasOtherContact: false,
    contactCity: null,
    contactStreet: null,
    contactZipCode: null,
    dataBox: null,
    isSourceEmployment: false,
    isSourceBusiness: false,
    isSourceSavings: false,
    isSourceRetirement: false,
});

// Shortens overly long city names from fox entry
// which includes unnecessary city district
const shortenCityName = (name: string) => {
    if (!name) return;
    if (name.length <= 32) return;

    if (name === "Nová Ves u Nového Města na Moravě") {
        return "Nová Ves u Nov. Města na Moravě";
    }

    let trimIndex = 32;
    [" - ", " – ", " okr. ", " okres ", " okr "].forEach((okr) => {
        const index = name.indexOf(okr);
        if (index > 0 && index < trimIndex) {
            trimIndex = index;
        }
    });

    return name.substring(0, trimIndex).trim();
};

watch(
    () => registrationPersonalData.value.city,
    (newVal) => {
        const shortenedValue = shortenCityName(newVal);
        if (shortenedValue) {
            registrationPersonalData.value.city = shortenedValue;
        }
    }
);

watch(
    () => registrationPersonalData.value.cityOfBirth,
    (newVal) => {
        const shortenedValue = shortenCityName(newVal);
        if (shortenedValue) {
            registrationPersonalData.value.cityOfBirth = shortenedValue;
        }
    }
);

const setBusinessCardData = (data: BusinessCardData) => {
    registrationPersonalData.value.isBankIdUsed = true;
    registrationPersonalData.value.firstName = data.firstName;
    registrationPersonalData.value.lastName = data.lastName;
    registrationPersonalData.value.phone = data.phone;
    registrationPersonalData.value.street = data.street;
    registrationPersonalData.value.city = shortenCityName(data.city) ?? data.city;
    registrationPersonalData.value.zipCode = data.zipCode;
    registrationPersonalData.value.countryOfBirth = data.countryOfBirth;
    registrationPersonalData.value.cityOfBirth = shortenCityName(data.cityOfBirth) ?? data.cityOfBirth;
    registrationPersonalData.value.citizenship = data.citizenship;
    registrationPersonalData.value.citizenshipId = data.citizenshipId;
};

const setPlayerDetailData = () => {
    const { user } = useRegistrationStore();
    registrationPersonalData.value.firstName = user.firstName;
    registrationPersonalData.value.lastName = user.lastName;
    registrationPersonalData.value.phone = user.phone?.substring(3);
    registrationPersonalData.value.street = user.street;
    registrationPersonalData.value.city = user.city;
    registrationPersonalData.value.zipCode = parseInt(user.zipCode);
    registrationPersonalData.value.citizenship = user.citizenship;
};

export default () => ({
    registrationPersonalData,
    setBusinessCardData,
    setPlayerDetailData,
});
